import React from 'react';
import { Link } from 'react-router-dom';

const LandingFooter = () => {
  return (
    <footer className="bg-primaryB-900 border-t border-primaryB-700/40 rounded-tl-[40px] rounded-tr-[40px]">
      <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-2 md:col-span-1">
            <Link to="/" className="flex items-center gap-3 mb-4">
              <img src="/images/logo.png" alt="SmartPOS Africa" className="w-10 h-10 rounded-2xl shadow-elevated" />
              <span className="text-white font-extrabold text-xl">Smart POS</span>
            </Link>
            <p className="text-primaryB-400 text-sm">
              Complete business management for African entrepreneurs.
            </p>
          </div>

          {/* Product */}
          <div>
            <h4 className="text-primaryB-200 font-bold mb-4">Product</h4>
            <ul className="space-y-2">
              <li><Link to="/features" className="text-primaryB-400 hover:text-primaryB-200 text-sm transition-all duration-200">Features</Link></li>
              <li><Link to="/pricing" className="text-primaryB-400 hover:text-primaryB-200 text-sm transition-all duration-200">Pricing</Link></li>
              <li><Link to="/blog" className="text-primaryB-400 hover:text-primaryB-200 text-sm transition-all duration-200">Blog</Link></li>
              <li><a href="/signup" className="text-primaryB-400 hover:text-primaryB-200 text-sm transition-all duration-200">Get Started</a></li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="text-primaryB-200 font-bold mb-4">Company</h4>
            <ul className="space-y-2">
              <li><Link to="/about" className="text-primaryB-400 hover:text-primaryB-200 text-sm transition-all duration-200">About Us</Link></li>
              <li><a href="https://wa.me/233559306229" target="_blank" rel="noopener noreferrer" className="text-primaryB-400 hover:text-primaryB-200 text-sm transition-all duration-200">Contact / Support</a></li>
              <li><Link to="/ghana" className="text-primaryB-400 hover:text-primaryB-200 text-sm transition-all duration-200">POS Software Ghana</Link></li>
              <li><Link to="/nigeria" className="text-primaryB-400 hover:text-primaryB-200 text-sm transition-all duration-200">POS Software Nigeria</Link></li>
            </ul>
          </div>

          {/* Legal */}
          <div>
            <h4 className="text-primaryB-200 font-bold mb-4">Legal</h4>
            <ul className="space-y-2">
              <li><Link to="/privacy" className="text-primaryB-400 hover:text-primaryB-200 text-sm transition-all duration-200">Privacy Policy</Link></li>
              <li><Link to="/terms" className="text-primaryB-400 hover:text-primaryB-200 text-sm transition-all duration-200">Terms of Service</Link></li>
            </ul>
          </div>
        </div>

        <div className="border-t border-primaryB-700/40 mt-12 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-primaryB-400 text-sm">
            &copy; {new Date().getFullYear()} Smart POS. All rights reserved.
          </p>
          <p className="text-primaryB-400 text-sm">
            Made with love in Ghana
          </p>
        </div>
      </div>
    </footer>
  );
};

export default LandingFooter;
